import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { CareerCard } from "../../shared/component/Card/Card";
import * as RoutePath from "../../shared/utils/routeLink";
import * as Variable from "../../shared/utils/variables";
import * as ActionTypes from "../../store/actions/actionTypes";
import ListingComponent from "../../shared/component/ListingComponent/ListingComponent";
import FilterBox from "../../shared/component/FilterBox/FilterBox";
import NoContentComponent from "../../shared/component/NoContentComponent/NoContentComponent";
import { toast } from "react-toastify";
import makeRequest from "../../shared/utils/request";
import { generateRequestOptions } from "../../shared/utils/apiEndPoints";
import { SearchIcon } from "../../shared/component/svg/Icons";
import useDebounce from "../../shared/hooks/debounce";
import { formatString } from "../../shared/utils/string";
import LoadingComponent from "../../shared/component/LoadingComponent/LoadingComponent";
import { uniqBy } from "lodash";
import { CareerListCard } from "../../shared/component/ListItem/ListItem";

const ITEMS_PER_PAGE = 60;

const sectorFilter = [
	{ sector: "Hukum - Politik - Pegawai Negeri", sector_count: 0 },
	{ sector: "Media - Hiburan", sector_count: 0 },
	{ sector: "Musik - Hubungan Acara", sector_count: 0 },
	{ sector: "Desain - Fotografi - Seni", sector_count: 0 },
	{ sector: "Mode", sector_count: 0 },
	{ sector: "Game - Komputer - Web", sector_count: 0 },
	{
		sector: "Wisata - Hotel - Bisnis Perjalanan - Pernikahan",
		sector_count: 0,
	},
	{ sector: "Bisnis - Keuangan - Real Estate", sector_count: 0 },
	{ sector: "Bahasa - Hubungan Internasional", sector_count: 0 },
	{ sector: "Medis - Kedokteran - Keperawatan", sector_count: 0 },
	{ sector: "Kecantikan - Tata Rias - Estetika", sector_count: 0 },
	{ sector: "Lingkungan - Alam - Bio", sector_count: 0 },
	{ sector: "Hewan - Tumbuhan", sector_count: 0 },
	{ sector: "Mekanis - Listrik - Elektronik - Kimia", sector_count: 0 },
	{ sector: "Otomotif - Penerbangan - Ruang Angkasa", sector_count: 0 },
	{ sector: "Arsitektur - Teknik sipil - Interior", sector_count: 0 },
];

const CareerListing = ({ ENV_NAME, isAuthenticated, fetchingAddRemoveFavorites, isComingSoon, ...props }) => {
	const [careers, setCareers] = useState(null);
	const [sectors, setSectors] = useState(null);
	const [isLoading, setIsLoading] = useState(null);
	const [isLoadingFilters, setIsLoadingFilters] = useState(null);
	const [filters, setFilters] = useState({
		sector: "allSector",
	});
	const [searchTemp, setSearchTemp] = useState("");
	const debounceSearch = useDebounce(searchTemp, 750);
	const [page, setPage] = useState(1);
	const [total, setTotal] = useState({
		has_next: false,
		total_items: 0,
	});
	const [view, setView] = useState("big");

	useEffect(() => {
		if (searchTemp !== filters?.search && (searchTemp.length >= 3 || searchTemp === "")) {
			setFilters((p) => ({ ...p, search: debounceSearch }));
		}
	}, [debounceSearch]); // eslint-disable-line

	useEffect(() => {
		setPage(1);
		getCareer(1);
	}, [filters]); // eslint-disable-line

	useEffect(() => {
		if (page > 1) getCareer(page);
	}, [page]); // eslint-disable-line

	useEffect(() => {
		const getSectors = async () => {
			setIsLoadingFilters(true);
			let res = await makeRequest(generateRequestOptions("sectorList"));
			if (res?.code === 200) {
				setSectors(
					uniqBy(
						[...res?.data?.filter((i) => i?.sector && i?.sector_count), ...sectorFilter],
						(_) => _.sector
					)
				);
			}

			setIsLoadingFilters(false);
		};

		getSectors();
	}, []);

	const getCareer = async (page) => {
		if (isLoading) return;
		setIsLoading(true);

		// Store the current value, and add the loading card
		// While the API is calling
		let currCareer = page === 1 ? [] : careers || [];
		setCareers([
			...currCareer,
			...[...Array(ITEMS_PER_PAGE)].map((i) => ({
				isLoading: true,
			})),
		]);

		let sectors = filters?.sector === "allSector" ? undefined : filters?.sector;

		let res = await makeRequest(
			generateRequestOptions("careerList", {
				queryParams: {
					page,
					page_size: ITEMS_PER_PAGE,
					search: filters?.search || undefined,
					sectors,
				},
			})
		);
		if (res.code === 200) {
			setCareers([...currCareer, ...res.data]);
			setTotal({ has_next: res.next, total_items: res.total_items });
		} else {
			setCareers(currCareer);
			setTotal((p) => ({ ...p, has_next: false }));
			toast.error(res.message || Variable.SOMETHING_WENT_WRONG_TRY_AGAIN[ENV_NAME]);
		}

		setIsLoading(false);
	};

	const onChangeField = (e, radio = false) => {
		if (radio) {
			setFilters((p) => ({ ...p, [e.target.name]: e.target.id }));
		} else {
			setFilters((p) => ({ ...p, [e.target.name]: e.target.checked }));
		}
	};

	return (
		<>
		{ isComingSoon ?
		 <NoContentComponent className="coming-soon-wrapper" title={Variable.COMING_SOON[ENV_NAME]} />
		: 
		<ListingComponent
			className="career-listing"
			hasView={true}
			view={view}
			setView={setView}
			filters={
				<>
					<FilterBox>
						<div className="form-group search-bar mb-0">
							<SearchIcon className="searchIcon" />
							<input
								type="text"
								name="searchText"
								value={searchTemp || ""}
								onChange={(e) => setSearchTemp(e.target.value)}
								placeholder={formatString(
									Variable.SRC_BY_PLACEHOLDER[ENV_NAME],
									Variable.CAREER[ENV_NAME]
								)}
							/>
						</div>
					</FilterBox>
					<FilterBox header={Variable.SECTOR[ENV_NAME]} collapsible={1} eventkey="0" opendefault={1}>
						<div className="form-group form-check">
							<input
								type="radio"
								className="form-check-input"
								id="allSector"
								name="sector"
								checked={filters?.sector === "allSector" || false}
								onChange={(e) => onChangeField(e, true)}
								disabled={isLoading}
							/>
							<label className="form-check-label" htmlFor="allSector">
								{Variable.ALL_SECTOR[ENV_NAME]}
								<span className="filter-count">{`(${total?.total_items})`}</span>
							</label>
						</div>
						{isLoadingFilters ? (
							<LoadingComponent notFullScreen loadingLabel=" " />
						) : (
							sectors?.map((i) => (
								<div className="form-group form-check" key={i?.sector}>
									<input
										type="radio"
										className="form-check-input"
										id={`${i?.sector}`}
										name="sector"
										checked={filters?.sector === `${i?.sector}` || false}
										onChange={(e) => onChangeField(e, true)}
										disabled={isLoading}
									/>
									<label className="form-check-label" htmlFor={`${i?.sector}`}>
										{i?.sector}
										<span className="filter-count">{`(${i?.sector_count || 0})`}</span>
									</label>
								</div>
							))
						)}
					</FilterBox>
				</>
			}
			contents={
				!isLoading && careers?.length === 0 ? (
					<NoContentComponent className="my-xl" description=" " />
				) : (
					(careers || [])?.map((i, idx) => (
						<Link
							key={i?.id || idx}
							to={i?.id ? RoutePath.CAREER_DETAIL + "/" + i?.id : ""}
							className="text-decoration-none text-label-dark-gray-2"
						>
							{view !== "list" ? (
								<CareerCard
									key={i?.id || idx}
									isLoading={i?.isLoading}
									data={i?.isLoading ? undefined : i}
									onClickFavorite={() => {
										if (i?.isLoading || fetchingAddRemoveFavorites) return;
										if (isAuthenticated) {
											props.addRemoveFavorite(
												i?.is_favourite ? "remove" : "add",
												"career",
												i?.is_favourite ? i?.fav_obj_id : i?.id,
												(res) => {
													setCareers((prev) =>
														prev.map((p) => {
															if (p?.id !== i?.id) return p;
															return {
																...p,
																is_favourite: !i?.is_favourite,
																fav_obj_id: i?.is_favourite ? null : res?.data?.id,
															};
														})
													);
												}
											);
										} else {
											props.openLoginModal();
										}
									}}
									onClick={() => {}}
									ENV_NAME={ENV_NAME}
									smallcard={view === "small"}
								/>
							) : (
								<CareerListCard
									key={i?.id || idx}
									isLoading={i?.isLoading}
									data={i?.isLoading ? undefined : i}
									onClickFavorite={() => {
										if (i?.isLoading || fetchingAddRemoveFavorites) return;
										if (isAuthenticated) {
											props.addRemoveFavorite(
												i?.is_favourite ? "remove" : "add",
												"career",
												i?.is_favourite ? i?.fav_obj_id : i?.id,
												(res) => {
													setCareers((prev) =>
														prev.map((p) => {
															if (p?.id !== i?.id) return p;
															return {
																...p,
																is_favourite: !i?.is_favourite,
																fav_obj_id: i?.is_favourite ? null : res?.data?.id,
															};
														})
													);
												}
											);
										} else {
											props.openLoginModal();
										}
									}}
									onClick={() => {}}
									ENV_NAME={ENV_NAME}
								/>
							)}
						</Link>
					))
				)
			}
			contentsClassName={!isLoading && careers?.length === 0 ? "no-grid" : undefined}
			showingLabel={`${total?.total_items || 0} ${Variable.CAREERS[ENV_NAME]}`}
			showMoreOnClick={() => !isLoading && setPage((p) => p + 1)}
			hasMore={!isLoading ? total.has_next : false}
		/> }
		</>
		
	);
};

const mapStateToProps = (state) => {
	return {
		isAuthenticated: state.auth.isAuthenticated,
		ENV_NAME: state.auth.selectedEnvironment || "bhs",
		fetchingAddRemoveFavorites: state.auth.fetchingAddRemoveFavorites,
		isComingSoon: true
	};
};

const mapStateToDispatch = (dispatch) => {
	return {
		openLoginModal: () =>
			dispatch({
				type: ActionTypes.OPEN_LOGIN_MODAL,
			}),
		addRemoveFavorite: (action, type, id, onSuccess = null, onFail = null) =>
			dispatch({
				type: ActionTypes.ADD_REMOVE_FAVORITE,
				data: { action, type, id },
				onSuccess,
				onFail,
			}),
	};
};

export default connect(mapStateToProps, mapStateToDispatch)(withRouter(CareerListing));
